/**
 * FAQ Accordion Web Component
 * - Only one item open at a time
 * - Smooth slide animation on open/close
 */
class FaqAccordion extends HTMLElement {
  constructor() {
    super();
    this.detailsElements = this.querySelectorAll('details');
    this.animationDuration = 300; // ms, should match CSS transition
  }

  connectedCallback() {
    this.detailsElements.forEach((details) => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');

      if (summary && content) {
        // Set initial max-height for open items
        if (details.open) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }

        summary.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleDetails(details, content);
        });
      }
    });
  }

  toggleDetails(targetDetails, content) {
    const isOpening = !targetDetails.open;

    if (isOpening) {
      // Close all other details first
      this.detailsElements.forEach((details) => {
        if (details !== targetDetails && details.open) {
          this.closeDetails(details);
        }
      });

      // Open the target
      this.openDetails(targetDetails, content);
    } else {
      // Close the target
      this.closeDetails(targetDetails);
    }
  }

  openDetails(details, content) {
    // Set the open attribute first
    details.open = true;

    // Force reflow to get accurate scrollHeight
    content.style.maxHeight = '0px';
    content.offsetHeight; // Force reflow

    // Animate to full height
    requestAnimationFrame(() => {
      content.style.maxHeight = content.scrollHeight + 'px';
    });

    // Remove max-height after animation to allow dynamic content
    setTimeout(() => {
      content.style.maxHeight = 'none';
    }, this.animationDuration);
  }

  closeDetails(details) {
    const content = details.querySelector('.accordion__content');
    if (!content) return;

    // Set current height explicitly before animating
    content.style.maxHeight = content.scrollHeight + 'px';
    content.offsetHeight; // Force reflow

    // Animate to 0
    requestAnimationFrame(() => {
      content.style.maxHeight = '0px';
    });

    // Remove open attribute after animation
    setTimeout(() => {
      details.open = false;
    }, this.animationDuration);
  }
}

customElements.define('faq-accordion', FaqAccordion);
